import ebiOfficeService from "api/ebiOfficeService";
import { Receiver } from "api/parcelService";
import { EParcelType } from "dto/EParcelType";
import { signEbiKeyBinding } from "./ebiKeyBinding";
import { encryptForCompanyAndRecipients } from "./encryptForCompany";

/**
 * Pisma EBI z „Generuj pisma” (docs/ebi-plan.md, etap 4): każdy adresat EBI dostaje WŁASNY klucz pisma, zawinięty
 * dla [klucz firmy + bieżący klucz petenta, jeśli już go ma]. Wtyczka szyfruje nim wygenerowany PDF, a BE zapisuje
 * klucz jako klucz obiektu adresata — petentowi udostępnia się wyłącznie jego pismo, nigdy wspólnego klucza dokumentu
 * (otwiera wszystkie wersje i kopie pisma). Petent bez klucza dostanie pismo po przeszyfrowaniu w urzędzie — tylko
 * z podpisanym kluczem firmy powiązaniem klucza z doręczeniem (decyzja D1).
 * Mutuje odbiorców (PublicKey/PrivateKey/EbiKeyBinding*). Rzuca przy braku klucza firmy albo błędzie pobrania kluczy petentów.
 */
export const attachEbiLetterKeys = async (receivers: Receiver[]): Promise<void> => {
  const ebi = receivers.filter((r) => r.Parcel === EParcelType.Ebi);

  if (!ebi.length) return;

  const petentKeys = await ebiOfficeService.getRecipientKeys(
    ebi.map((r) => Number(r.Id)).filter((id) => id > 0),
  );

  for (const receiver of ebi) {
    const petentKey = petentKeys.find((k) => k.ParticipantId === Number(receiver.Id))?.PublicKey;
    const key = await encryptForCompanyAndRecipients([petentKey]);

    receiver.PublicKey = key.PublicKey;
    receiver.PrivateKey = key.PrivateKey;
    Object.assign(receiver, await signEbiKeyBinding(key.cleanPublicKey.keys[0], Number(receiver.Id)));
  }
};

/** Klucz, którym wtyczka zaszyfruje PDF adresata: klucz pisma EBI albo pusty = klucz dokumentu. */
export const letterPublicKeyFor = (receiver: Receiver): string =>
  receiver.Parcel === EParcelType.Ebi ? receiver.PublicKey ?? "" : "";
